// @ts-check

import React from 'react';
import { func, string } from 'prop-types';
import USER from '../ts/profileEditorEnum';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import CloseIcon from '@mui/icons-material/Close';
import ProfilePaper from './ProfilePaper';

/**
 * @component ProfileEditorNotes
 * @param {Object} props
 * @param {string} props.notes
 * @param {(name:string, payload: any)=>void} props.onHandle
 * @returns {JSX.Element}
 */
function ProfileEditorNotes({ notes, onHandle }) {
	return (
		<ProfilePaper>
			<Typography variant="button">NOTES</Typography>
			<TextField
				name={USER.NOTES}
				label="Notes"
				multiline
				value={notes}
				size="small"
				InputLabelProps={{ shrink: true }}
				onChange={(e) => onHandle(USER.NOTES, e.target.value)}
				InputProps={{
					endAdornment: (
						<InputAdornment position="end">
							<Tooltip title="Clear">
								<IconButton onClick={() => onHandle(USER.NOTES, '')}>
									<CloseIcon fontSize="small" />
								</IconButton>
							</Tooltip>
						</InputAdornment>
					),
				}}
			/>
		</ProfilePaper>
	);
}

ProfileEditorNotes.propTypes = { notes: string, onHandle: func };

export default ProfileEditorNotes;
